import { useQuery } from "@tanstack/react-query";

import { apiClient } from "../../../lib/api";

export const circlesQueryKey = ["circles"];

export function useCircleData(selectedCircleId: string | null) {
  const circlesQuery = useQuery({
    queryKey: circlesQueryKey,
    queryFn: () => apiClient.getCircles(),
  });

  const meQuery = useQuery({
    queryKey: ["me"],
    queryFn: () => apiClient.getCurrentUser(),
  });

  const activeCircleId = selectedCircleId ?? circlesQuery.data?.[0]?.id ?? null;
  const activeCircle = circlesQuery.data?.find((circle) => circle.id === activeCircleId) ?? null;
  const isOwner = activeCircle?.myMembership.role === "OWNER";

  const membersQuery = useQuery({
    queryKey: ["circle-members", activeCircleId],
    queryFn: () => apiClient.getCircleMembers(activeCircleId!),
    enabled: !!activeCircleId,
  });

  const invitesQuery = useQuery({
    queryKey: ["circle-invites", activeCircleId],
    queryFn: () => apiClient.getCircleInvites(activeCircleId!),
    enabled: !!activeCircleId && isOwner,
  });

  const eventsQuery = useQuery({
    queryKey: ["circle-events", activeCircleId],
    queryFn: () => apiClient.getCircleEvents(activeCircleId!),
    enabled: !!activeCircleId,
  });

  const commentsQuery = useQuery({
    queryKey: ["circle-comments", activeCircleId],
    queryFn: () => apiClient.getCircleComments(activeCircleId!),
    enabled: !!activeCircleId,
  });

  const progressQuery = useQuery({
    queryKey: ["circle-progress", activeCircleId],
    queryFn: () => apiClient.getCircleProgress(activeCircleId!),
    enabled: !!activeCircleId,
  });

  const sharedGoals = (progressQuery.data?.members ?? [])
    .filter((member) => member.userId !== meQuery.data?.id)
    .flatMap((member) => member.goals);

  return {
    activeCircle,
    activeCircleId,
    circles: circlesQuery.data,
    circlesQuery,
    comments: commentsQuery.data ?? [],
    events: eventsQuery.data ?? [],
    invites: invitesQuery.data,
    invitesQuery,
    isOwner,
    me: meQuery.data,
    members: membersQuery.data,
    membersQuery,
    progressQuery,
    sharedGoals,
  };
}
